module.exports = __webpack_public_path__ + "b3631d81e3b28c9cbe44fe74a46816b6.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/shop/golf-channel.jpg
 ** module id = 474
 ** module chunks = 0
 **/